<template>
  <div>
    <label class="switch">
      <input type="checkbox"
             @input="changed"
             :checked="value">
      <span class="slider round"></span>
    </label>
    <span v-if="label" class="ml-2 small">{{ label }}</span>
  </div>
</template>

<script setup>
const emit = defineEmits(['input'])

defineProps({
  value: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
  }
})

const changed = (val) => {
  emit('input', val.target.checked)
}
</script>

<style scoped lang="scss">
.switch {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 24px;
  margin-bottom: 0;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .2s;
  transition: .2s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
}

input:checked + .slider {
  background-color: $blue-color;
}

input:focus + .slider {
  box-shadow: 0 0 1px $blue-color;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
